import { faDatabase } from '@fortawesome/free-solid-svg-icons'

// Импорт иконок
import groups_icon from '../../../img/groups.svg';
import documents_icon from '../../../img/documents.svg';
import staff_icon from '../../../img/staff.svg';
import base_icon from '../../../img/base.svg';
import passport_icon from '../../../img/passport.svg';
import zvit_icon from '../../../img/zvit.svg';
import parents_icon from '../../../img/parents.svg';
import orders_icon from '../../../img/orders.svg';
import statistic_icon from '../../../img/statistic.svg';
import location_icon from '../../../img/location.svg';
import collection_icon from '../../../img/collection-fill.svg';
import info_icon from '../../../img/info-circle-fill.svg'
import childrens_icon from '../../../img/person-lines-fill.svg';
import sms_icon from '../../../img/send-check-fill.svg';
import messages_icon from '../../../img/envelope-paper-fill.svg'
import personalcab_icon from '../../../img/person-hearts.svg';

import diagram_3_icon from '../../../img/diagram-3-fill.svg';


  // Кабінет технічної підтримки = рівень модератора, але ТІЛЬКИ ПЕРЕГЛЯД.
  // Меню повторює модераторське, за винятком пунктів, які є чистими точками
  // входу на запис і в режимі перегляду не мають сенсу:
  //   - orderNew  ("Створити заявку")
  //   - addKindergarten ("Додати ЗДО")
  //   - smsnotif ("СМС")  — розсилка
  // Решта екранів відкривається у режимі перегляду (mode.application: "view"),
  // редагування довідників вимкнено (dictionaryEdit: all false).

  const title = '';


  const rightPossible = {
    isPossibleAddGroup: false,
    dictionaryEdit: {
      docs: false,
      positions: false,
      years: false
    },
    mode: {
      application: "view"
    }
  }

  const menuItems = [
    {
        "id": "statistica",
        "label": "Статистика",
        "icon": statistic_icon,
        hasDropdown: true
    },
    {
        "id": "orderlist",
        "label": "Заявки",
        "icon": orders_icon
    },
    {
        "id": "infoApprovedBenefits",
        "label": "Інфо",
        "icon": info_icon
    },
    {
        "id": "showChildren",
        "label": "Діти",
        "icon": childrens_icon
    },
    {
        "id": "staffRulles",
        "label": "Правила ШОД",
        "icon": base_icon
    },
    {
        "id": "messages",
        "label": "Повідомлення",
        "icon": messages_icon
    },
    {
        "id": "checkRegKyiv",
        "label": "Перевірка реєстрації",
        "icon": parents_icon
    },
    {
        "id": "reports",
        "label": "Звітність",
        "icon": zvit_icon
    },
    {
      id: 'dictionary',
      label: 'Довідники',
      icon: collection_icon,
      hasDropdown: true,
      href: '#',
      badge: null
    }
  ];



  const level2Items = {
    "statistica": [
        {
          "id": "queue",
          "label": "Заявки"
        },
        {
          "id": "child",
          "label": "Діти у садочках"
        },
        {
          "id": "groups",
          "label": "Групи поточні"
        },
        {
          "id": "groups_arch",
          "label": "Групи архівні"
        },
        {
          "id": "invites",
          "label": "Запрошення"
        },
        {
          "id": "attends",
          "label": "Відвідування"
        },
        {
          "id": "bfn",
          "label": "БФН"
        },
        {
          "id": "benefits",
          "label": "Пільги"
        },
        {
          "id": "queue_kg",
          "label": "Черга по садочкам"
        },
        {
          "id": "staff_zdo",
          "label": "Штатний розпис і працівники"
        }
    ],
    "dictionary": [
        {
            id: 'dict_docs',
            label: 'Типи документів',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'proffessions',
            label: 'Найменування посад',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            "id": "roles",
            "label": "Ролі",
            "icon": ""
        },
        {
            "id": "kitchen",
            "label": "Кухня",
            "icon": ""
        },
        {
            "id": "finans",
            "label": "Гроші за дитиною",
            "icon": ""
        },
        {
            id: 'years_dict',
            label: 'Навчальний  рік',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'dict_places',
            label: 'Типи місць',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'disct_spec',
            label: 'Спеціалізація',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'disct_diss',
            label: 'Вид захворювання',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
    ],
    "kindergartens": [
      {
          "id": "editKindergarten",
          "label": "Перелік ЗДО",
          "icon": passport_icon
      }
    ],
    "base": [
        {
            id: 'base_bda',
            label: 'Приміщення',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'base_pc',
            label: 'Компьютери',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        }
    ]
  }

  const additionalLinks = [

    {
      id: 'all-kindergartens',
      label: 'Всі садочки',
      icon: location_icon,
      href: '/kglist'
    },
    {
      id: 'statistics',
      label: 'Статистика публічна',
      icon: statistic_icon,
      href: '/publicstatistics'
    },
    {
      id: 'statistics',
      label: 'Мій кабінет батьків',
      icon: personalcab_icon,
      href: '/cabinet',
      active: false
    }
  ];

  const cabinetName = "Технічна підтримка";

  const Menu = { menuItems, level2Items, additionalLinks, title, cabinetName, rightPossible };

  export { menuItems, level2Items, additionalLinks, title };

  export default Menu;